import {Module} from '@nestjs/common';
import { QualificationController } from './qualifications.controller';
import { QualificationService } from './qualifications.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { QualificationAdapter } from './dto/qualifications.adapter';
import { Qualifications } from './qualifications.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
    imports: [
        TypeOrmModule.forFeature([Qualifications]),
    ],
    controllers: [QualificationController],
    providers: [QualificationService, QualificationAdapter, ApplicationExceptionHandler,LogsService],
    exports: [QualificationService],
})
export class QualificationModule{}